import { Check } from "lucide-react";

type Props = {
  steps: string[];
  current: number;
};

export function Stepper({ steps, current }: Props) {
  return (
    <ol className="flex items-center gap-2">
      {steps.map((label, idx) => {
        const done = idx < current;
        const active = idx === current;
        return (
          <li key={label} className="flex flex-1 items-center gap-2">
            <div
              className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-[10px] font-semibold ${
                done
                  ? "bg-brand-600 text-white"
                  : active
                  ? "bg-brand-100 text-brand-700 ring-2 ring-brand-600"
                  : "bg-zinc-200 text-zinc-500"
              }`}
            >
              {done ? <Check className="h-3 w-3" /> : idx + 1}
            </div>
            <span
              className={`text-[11px] font-medium ${
                active ? "text-zinc-900" : "text-zinc-500"
              }`}
            >
              {label}
            </span>
            {idx < steps.length - 1 && (
              <div
                className={`mx-1 hidden h-px flex-1 sm:block ${
                  done ? "bg-brand-600" : "bg-zinc-200"
                }`}
              />
            )}
          </li>
        );
      })}
    </ol>
  );
}
